var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.2222222px",
    height: "6px",
    viewBox: "0 0 10.2222222 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDownNav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowDownNav",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24990554,-2.11111111 C7.47893887,-2.11111111 7.69848775,-2.02036023 7.85977341,-1.85902125 C8.19489035,-1.52214961 8.19489035,-0.980604934 7.85977341,-0.64373329 L4.19211111,2.99988889 L7.85977341,6.64458553 C8.19478911,6.98116646 8.19478911,7.52244032 7.85977341,7.85902125 C7.69848775,8.02036023 7.47893887,8.11111111 7.24990554,8.11111111 C7.0208722,8.11111111 6.80132332,8.02036023 6.64003767,7.85902125 L2.36237289,3.60721786 C2.02735719,3.27063693 2.02735719,2.72936307 2.36237289,2.39278214 L6.64003767,-1.85902125 C6.80132332,-2.02036023 7.0208722,-2.11111111 7.24990554,-2.11111111 Z",
    fill: "#979598",
    transform: "translate(5.111111, 3.000000) rotate(-90.000000) translate(-5.111111, -3.000000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.b5cbb7688d479cae71607ed7d42abfc2.svg";
export { ForwardRef as ReactComponent };